import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function cra(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@cra/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cra/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cra/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@cra/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@cra/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@cra/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}